import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/EnergyManagementPage.css";

const EnergyManagementPage = () => {
  return (
    <>
      <Header />

      <section
        className="energy-banner"
        style={{
          backgroundImage:
            "url('/wp-content/uploads/2025/02/Energy Management Page.png')",
        }}
      ></section>

      <div className="energy-wrapper">
        <div className="center-container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Energy Management</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">
            Energy Management
          </h1>

          <div className="energy-content">
            <p className="energy-text" data-aos="fade-up">
              Dedicated to optimizing energy performance and promoting
              sustainable practices across all operations. As part of this
              commitment, we have adopted and integrated ISO 50001:2018 — the
              international standard for energy management systems. This
              certification reflects our systematic approach to energy
              efficiency, continual improvement, and reducing environmental
              impact.
            </p>

            <div
              className="energy-certificate"
            >
              <a
                href="/wp-content/uploads/2025/02/ISO 50001 2018 Certificate.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/wp-content/uploads/2025/02/ISO 50001 2018.png"
                  alt="ISO 50001:2018 Certificate"
                  data-aos="zoom-in"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default EnergyManagementPage;
